import { PublicClientApplication, EventType, InteractionType, RedirectRequest } from '@azure/msal-browser'
import { msalConfig, protectedResources } from '../../authConfig'
import { saveUserToken } from '@src/shared/providers/UserProvider'
import { JwtToken, signIn } from '@src/shared/services/user-api'

const msalInstance = new PublicClientApplication(msalConfig)

let onTokenAcquired: ((jwt: string) => void) | null = null

export function setOnTokenAcquired(callback: (jwt: string) => void) {
  onTokenAcquired = callback
}

export async function initializeMsal(): Promise<PublicClientApplication> {
  await msalInstance.initialize()

  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0])
  }

  msalInstance.addEventCallback(async (event) => {
    if (
      event.eventType === EventType.LOGIN_SUCCESS ||
      (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.interactionType === InteractionType.Redirect)
    ) {
      const { account } = event.payload as RedirectRequest
      if (account) {
        msalInstance.setActiveAccount(account)

        const responseToken = await msalInstance.acquireTokenSilent({
          account,
          scopes: protectedResources.getTokenAzure.scopes.read,
        })

        const token: JwtToken = { jwt: responseToken.accessToken }
        const responseIceberg = await signIn(token)

        saveUserToken(responseIceberg.jwt)

        if (onTokenAcquired) {
          onTokenAcquired(responseIceberg.jwt)
        } else {
          window.location.reload()
        }
      }
    }
  })

  return msalInstance
}
